import { GetBaseServiceFunctions } from '../baseService'

const BaseRoute = 'app/hourly-rates'

const baseFunctions = GetBaseServiceFunctions(BaseRoute)

const API = {
  ...baseFunctions,
}

export default API
